import { Ref, ref } from "vue";
import { gtagSend } from "vue-app/plugins/edroneGtag";

const videoUrl: Ref<string | null> = ref(null);
const showVideo = ref(false);

export default () => {
  const playVideo = (url: string) => {
    videoUrl.value = url;
    showVideo.value = true;

    gtagSend({
      event: "button_click",
      component_type: "secondary",
      component_variant: "default",
      component_icon_name: "no_icon",
      component_state: "active",
      component_label: "edrone",
      functionality_group: "dashboard",
      functionality: "onboarding_video",
      text: url,
    });
  };

  const closeVideo = () => {
    videoUrl.value = null;
    showVideo.value = false;
  };

  return {
    playVideo,
    videoUrl,
    showVideo,
    closeVideo,
  };
};
